document.addEventListener('DOMContentLoaded', () => {

  class JewelryCalculator {

    constructor(wrapper){

      this.wrapper = wrapper;

      this.CONFIG = window.JQ_CONFIG;

      this.SHEET_ID =
        wrapper.dataset.sheetId;

      this.GID =
        wrapper.dataset.sheetGid;

      this.CSV_URL =
        `https://docs.google.com/spreadsheets/d/${this.SHEET_ID}/export?format=csv&gid=${this.GID}`;

      this.state = {
        goldRates:{
          g14:0,
          g18:0,
          g9:0
        }
      };

      this.cacheDOM();

      this.bindEvents();

      this.fetchRates();
    }

    cacheDOM(){

      this.dom = {

        card:
          this.wrapper.querySelector('.quote-card'),

        goldRate:
          this.wrapper.querySelector('[data-gold-rate]'),

        goldWeight:
          this.wrapper.querySelector('[data-gold-weight]'),

        goldTotal:
          this.wrapper.querySelector('[data-gold-total]'),

        mcRate:
          this.wrapper.querySelector('[data-mc-rate]'),

        mcQty:
          this.wrapper.querySelector('[data-mc-qty]'),

        mcTotal:
          this.wrapper.querySelector('[data-mc-total]'),

        regularSubtotal:
          this.wrapper.querySelector('[data-regular-subtotal]'),

        memberSubtotal:
          this.wrapper.querySelector('[data-member-subtotal]'),

        regularGST:
          this.wrapper.querySelector('[data-regular-gst]'),

        memberGST:
          this.wrapper.querySelector('[data-member-gst]'),

        regularFinal:
          this.wrapper.querySelector('[data-regular-final]'),

        memberFinal:
          this.wrapper.querySelector('[data-member-final]'),

        diamondRegular:
          this.wrapper.querySelector('[data-diamond-regular]'),

        diamondMember:
          this.wrapper.querySelector('[data-diamond-member]'),

        status:
          this.wrapper.querySelector('[data-status-tag]'),

        refresh:
          this.wrapper.querySelector('[data-refresh-btn]')
      };

      this.diamondRows =
        [...this.wrapper.querySelectorAll('.diamond-row')];
    }

    bindEvents(){

      this.wrapper.addEventListener(
        'input',
        () => this.calculate()
      );

      this.wrapper.addEventListener(
        'change',
        e => {

    if (e.target.name === 'gold_type') {

      if (e.target.value === 'g14') {
        this.dom.goldRate.value = this.state.goldRates.g14;
      } 
      else if (e.target.value === 'g18') {
        this.dom.goldRate.value = this.state.goldRates.g18;
      } 
      else if (e.target.value === 'g9') {
        this.dom.goldRate.value = this.state.goldRates.g9;
      }

      this.calculate();
    }

          if(e.target.name === 'view_mode'){

            if(e.target.value === 'member'){

              this.dom.card.classList.add(
                'member-only-active'
              );

            }else{

              this.dom.card.classList.remove(
                'member-only-active'
              );
            }
          }
        }
      );

      this.dom.refresh.addEventListener(
        'click',
        () => this.fetchRates()
      );
    }

    format(num){

      return new Intl.NumberFormat('en-IN')
        .format(Math.round(num || 0));
    }

    calculate(){

      const goldWeight =
        parseFloat(this.dom.goldWeight.value) || 0;

      const goldRate =
        parseFloat(this.dom.goldRate.value) || 0;

      const goldTotal =
        goldWeight * goldRate;

      this.dom.goldTotal.textContent =
        this.format(goldTotal);

      let regularDiamond = 0;
      let memberDiamond = 0;

      this.diamondRows.forEach(row => {

        const rate =
          parseFloat(
            row.querySelector('[data-dia-rate]').value
          ) || 0;

        const weight =
          parseFloat(
            row.querySelector('[data-dia-weight]').value
          ) || 0;

        const total =
          rate * weight;

        row.querySelector('[data-dia-total]')
          .textContent =
            this.format(total);

        regularDiamond += total;

        const isSmall =
          row.dataset.small === 'true';

        memberDiamond +=
          total * (
            isSmall
              ? this.CONFIG.small_discount
              : this.CONFIG.large_discount
          );
      });

      this.dom.diamondRegular.textContent =
        this.format(regularDiamond);

      this.dom.diamondMember.textContent =
        this.format(memberDiamond);

        let mcRate;

        const hasLargeDiamond =
        regularDiamond > 0 &&
        this.diamondRows
            .slice(1)
            .some(row => {

            const weight =
                parseFloat(
                row.querySelector('[data-dia-weight]').value
                ) || 0;

            return weight > 0;
            });

        const isPromo =
        new Date() <
        new Date(this.CONFIG.promo_end);

        if (isPromo) {

        mcRate =
            this.CONFIG.promo_mc;

        } else if (hasLargeDiamond) {

        mcRate =
            this.CONFIG.large_mc;

        } else {

        mcRate =
            this.CONFIG.default_mc;
        }

        this.dom.mcRate.value = mcRate;

        const mcTotal = mcRate * goldWeight;

      this.dom.mcQty.value = goldWeight.toFixed(2);

      this.dom.mcTotal.textContent = this.format(mcTotal);

      const regularSubtotal =
        goldTotal +
        regularDiamond +
        mcTotal;

      const memberSubtotal =
        goldTotal +
        memberDiamond +
        mcTotal;

      const gstRate =
        this.CONFIG.gst / 100;

      const regularGST =
        regularSubtotal * gstRate;

      const memberGST =
        memberSubtotal * gstRate;

      const regularFinal =
        regularSubtotal + regularGST;

      const memberFinal =
        memberSubtotal + memberGST;

      this.dom.regularSubtotal.textContent =
        this.format(regularSubtotal);

      this.dom.memberSubtotal.textContent =
        this.format(memberSubtotal);

      this.dom.regularGST.textContent =
        this.format(regularGST);

      this.dom.memberGST.textContent =
        this.format(memberGST);

      this.dom.regularFinal.textContent =
        this.format(regularFinal);

      this.dom.memberFinal.textContent =
        this.format(memberFinal);
    }

    async fetchRates(){

      this.dom.status.textContent =
        'Fetching...';

      try{

        const response =
          await fetch(this.CSV_URL);

        const csv =
          await response.text();

        const rows =
          csv
            .split(/\r?\n/)
            .map(r => r.split(','));

        this.state.goldRates.g14 =
          parseFloat(rows[1][1]) || 0;

        this.state.goldRates.g18 =
          parseFloat(rows[2][1]) || 0;

        this.state.goldRates.g9 =
          parseFloat(rows[3][1]) || 0;

        this.dom.goldRate.value =
          this.state.goldRates.g14;

        this.diamondRows[0]
          .querySelector('[data-dia-rate]')
          .value = parseFloat(rows[8][1]) || 0;

        this.diamondRows[1]
          .querySelector('[data-dia-rate]')
          .value = parseFloat(rows[9][1]) || 0;

        this.diamondRows[2]
          .querySelector('[data-dia-rate]')
          .value = parseFloat(rows[10][1]) || 0;

        this.diamondRows[3]
          .querySelector('[data-dia-rate]')
          .value = parseFloat(rows[11][1]) || 0;

        this.diamondRows[4]
          .querySelector('[data-dia-rate]')
          .value = parseFloat(rows[12][1]) || 0;

        this.diamondRows[5]
          .querySelector('[data-dia-rate]')
          .value = parseFloat(rows[13][1]) || 0;

        this.dom.status.textContent =
          'Rates Synced';

        this.calculate();

      }catch(error){

        console.error(error);

        this.dom.status.textContent =
          'Fetch Failed';
      }
    }
  }

  document
    .querySelectorAll('.jq-wrapper')
    .forEach(wrapper => {

      new JewelryCalculator(wrapper);
    });

});